

import SubHeading from "../SubHeading/SubHeading";
import "./Newsletter.css";
import { images } from "../../constants"

const Newsletter = () => (
  <div className="app__newsletter">
    <div className="app__newsletter-heading">
      <SubHeading title="Social Media" />
      <h2 className="headtext__cormorant">
        Subscribe To Our Social Media handles
      </h2>
      <p className="p__opensans">And never miss latest Updates!</p>
    </div>
    <div className="app__newsletter-input flex__center">
      <a
        href="https://facebook.com/p/Wok-and-Fire-100070460065791/"
        target="_blank"
        rel="noopener noreferrer"
        className="app__social-card"
      >
        <img
          src={images.fb}
          alt="Facebook Logo"
          title="Facebook Logo"
          className="social-logo"
        />
        <div className="app__social-card-content">
          <h3 className="font_base">Facebook</h3>
        </div>
      </a>

      <a
        href="https://www.instagram.com/wokandfireuk?igsh=OGdka2s3dWV0dTNm"
        target="_blank"
        rel="noopener noreferrer"
        className="app__social-card"
      >
        <img
          src={images.intsa}
          alt="Instagram Logo "
          title="Instagram Logo"
          className="social-logo"
        />
        <div className="app__social-card-content">
          <h3 className="font_base">Instagram</h3>
        </div>
      </a>
      <a
        href="https://www.tiktok.com/@wokandfireukhalal"
        target="_blank"
        rel="noopener noreferrer"
        className="app__social-card"
      >
        <img
          src={images.tiktok}
          alt="TikTok Logo"
          title="TikTok Logo"
          className="social-logo"
        />
        <div className="app__social-card-content">
          <h3 className="font_base">TikTok</h3>
        </div>
      </a>
    </div>
  </div>

);

export default Newsletter;
